import { render } from "./WrongTradeModal.vue?vue&type=template&id=36ca31e4"
import script from "./WrongTradeModal.vue?vue&type=script&lang=js"
export * from "./WrongTradeModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__